/**
 * Respuesta twilio.chats: array legacy o { chats, pagination }.
 * Módulo aparte para compatibilidad con Vue CLI 4 / webpack.
 */
export default function parseTwilioChatsResponse (data) {
  if (Array.isArray(data)) {
    return {
      chats: data,
      pagination: { hasMore: false, offset: 0, returned: data.length, limit: null },
    }
  }

  var chats = data && Array.isArray(data.chats) ? data.chats : []
  return {
    chats: chats,
    pagination: (data && data.pagination) || {
      hasMore: false,
      offset: 0,
      returned: chats.length,
      limit: null,
    },
  }
}
